import api from './api';

export interface UserBrief {
  id: number;
  email: string;
  full_name: string;
  avatar_url: string | null;
}

export interface LastMessage {
  body: string;
  created_at: string;
  is_mine: boolean;
}

export interface Conversation {
  id: number;
  created_at: string;
  other_participant: UserBrief | null;
  last_message: LastMessage | null;
  unread_count: number;
}

export interface Message {
  id: number;
  body: string;
  created_at: string;
  is_read: boolean;
  is_mine: boolean;
}

export interface MessageListResponse {
  count: number;
  next: number | null;
  results: Message[];
}

export const fetchConversations = (): Promise<Conversation[]> =>
  api.get('messages/conversations/').then((r) => r.data);

export const createConversation = (recipientId: number): Promise<Conversation> =>
  api.post('messages/conversations/', { recipient_id: recipientId }).then((r) => r.data);

export const fetchMessages = (
  conversationId: number,
  page = 1
): Promise<MessageListResponse> =>
  api
    .get(`messages/conversations/${conversationId}/messages/`, { params: { page } })
    .then((r) => r.data);

export const sendMessage = (conversationId: number, body: string): Promise<Message> =>
  api
    .post(`messages/conversations/${conversationId}/messages/`, { body })
    .then((r) => r.data);

export const markConversationRead = (conversationId: number): Promise<{ updated: number }> =>
  api.post(`messages/conversations/${conversationId}/read/`).then((r) => r.data);

export const fetchMessageUnreadCount = (): Promise<{ count: number }> =>
  api.get('messages/unread-count/').then((r) => r.data);

export const searchUsers = (q: string): Promise<{ results: UserBrief[] }> =>
  api.get('messages/users/search/', { params: { q } }).then((r) => r.data);
